const itemMapping = {
    'Item 1': 'fire.png',
    'Item 2': 'water.png',
    'Item 3': 'wind.png',
    'Item 4': 'earth.png',
    'Item 5': 'bubble potion.png',
    'Item 6': 'steam.png',
    'Item 7': 'dusty cloud.png',
    'Item 8': 'lava rock.png',
    'Item 9': 'aqua breeze.png',
    'Item 10': 'cold breeze.png',
    'Item 11': 'mud ball.png',
    'Item 12': 'smoke bomb.png',
    'Item 13': 'clay brick.png',
    'Item 14': 'blaze gem.png',
    'Item 15': 'stone block.png',

  };
  
  export default itemMapping;
  